import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MessageToast, ToastMode } from "../shared/MessageToast";
import { Customer } from "../shared/interfaces/Customer";
import { ResultListRequestType } from "../shared/apiHandlers/ResultsAPIs";
import { useResultsList } from "../data/useResultsList";
import { ResultsGrid } from "./ResultsGrid";
import { TabLabels } from "../shared/enums/Results";

interface Props {
  requestType: ResultListRequestType | undefined;
  selectedCustomer: Customer | undefined;
  selectedTab: TabLabels.MyCompleteResults | TabLabels.MyPartialResults;
  companyId: number;
  siteId: number;
  handleUploadButtonClick: () => void;
}

export function UserResults(props: Props) {
  const { t } = useTranslation();

  const [errorToast, setErrorToast] = useState({
    show: false,
    mode: ToastMode.Error,
    text: "",
  });

  const results = useResultsList(props.requestType, undefined);

  useEffect(() => {
    const handleError = async () => {
      if (results.error) {
        let errorMessage = await results.error.text();
        errorMessage = removeQuotes(errorMessage);
        setErrorToast({
          text:
            errorMessage ||
            (results.error.status === 403
              ? t("common.permissionError")
              : t("common.dataFetchError", { val: "$t(results.results)" })),
          mode: ToastMode.Error,
          show: true,
        });
      } else {
        setErrorToast({
          text: "",
          mode: ToastMode.Error,
          show: false,
        });
      }
    };

    handleError();
  }, [results?.error, t]);

  const removeQuotes = (stringValue: string) => {
    return stringValue.replace(/['"]+/g, "");
  };

  return (
    <React.Fragment>
      {errorToast.show ? (
        <div className="w-100 d-flex justify-content-center pt-2">
          <MessageToast text={errorToast.text} mode={errorToast.mode} show={errorToast.show}></MessageToast>
        </div>
      ) : (
        (results?.data || results?.isLoading) &&
        props.selectedCustomer && (
          <>
            <div className="pt-3">
              <ResultsGrid
                resultData={results?.data}
                resultDataLoading={results.isLoading}
                resultDataFetching={results.isFetching}
                partialResults={props.selectedTab === TabLabels.MyPartialResults}
                customerId={props.selectedCustomer.id}
                companyId={props.companyId}
                siteId={props.siteId}
                onDataRefreshClick={results.refetch}
                onUploadButtonClick={props.handleUploadButtonClick}
              />
            </div>
          </>
        )
      )}
    </React.Fragment>
  );
}
